export interface KeyLabelPair {
  key: string;
  label: string;
}
export interface IOrderStatusSelection {
  orderStatus: string;
  label: string;
}
export interface NotificationFilter {
  orderStatus: IOrderStatusSelection[];
  account: KeyLabelPair;
}

export enum FilterChipSignal {
  Account = 'account',
  OrderStatus = 'orderStatus'
}

export interface NotificationStatusChipsProps {
  notificationFilter: NotificationFilter;
  setFilterChip: (signal: FilterChipSignal, option?: string) => void;
}
